"use client";
import React from "react";
import Header from "../component/Header.jsx";
import Footer from "../component/Footer.jsx";
import SkillBar from "../component/SkillBar.jsx";
import { slidesBrand, slidesTestimonail } from "../utilities/constant";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { Link } from "react-router-dom";

const page = () => {
  return (
    <>
      <Header />
      {/* <!-- Page Banner Start --> */}
      <div
        className="section page-banner-section"
        style={{ backgroundImage: "url(/images/bg/page-banner.jpg)" }}
      >
        <div className="shape-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="944px" height="894px">
            <defs>
              <linearGradient
                id="PSgrad_0"
                x1="88.295%"
                x2="0%"
                y1="0%"
                y2="46.947%"
              >
                <stop offset="0%" stopColor="rgb(67,186,255)" stopOpacity="1" />
                <stop
                  offset="100%"
                  stopColor="rgb(113,65,177)"
                  stopOpacity="1"
                />
              </linearGradient>
            </defs>
            <path
              fillRule="evenodd"
              fill="rgb(43, 142, 254)"
              d="M39.612,410.76 L467.344,29.824 C516.51,-13.476 590.638,-9.93 633.938,39.613 L914.192,317.344 C957.492,366.50 953.109,440.637 904.402,483.938 L476.671,864.191 C427.964,907.492 353.376,903.109 310.76,854.402 L29.823,576.670 C-13.477,527.963 -9.94,453.376 39.612,410.76 Z"
            />
            <path
              fill="url(#PSgrad_0)"
              d="M39.612,410.76 L467.344,29.824 C516.51,-13.476 590.638,-9.93 633.938,39.613 L914.192,317.344 C957.492,366.50 953.109,440.637 904.402,483.938 L476.671,864.191 C427.964,907.492 353.376,903.109 310.76,854.402 L29.823,576.670 C-13.477,527.963 -9.94,453.376 39.612,410.76 Z"
            />
          </svg>
        </div>
        <div className="shape-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="726.5px"
            height="726.5px"
          >
            <path
              fillRule="evenodd"
              stroke="rgb(255, 255, 255)"
              strokeWidth="1px"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              opacity="0.302"
              fill="none"
              d="M28.14,285.269 L325.37,21.217 C358.860,-8.851 410.655,-5.808 440.723,28.14 L704.777,325.36 C734.846,358.859 731.802,410.654 697.979,440.722 L400.955,704.776 C367.132,734.844 315.338,731.802 285.269,697.978 L21.216,400.954 C-8.852,367.132 -5.808,315.337 28.14,285.269 Z"
            />
          </svg>
        </div>
        <div className="shape-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="515px" height="515px">
            <defs>
              <linearGradient
                id="PSgrad_0"
                x1="0%"
                x2="89.879%"
                y1="0%"
                y2="43.837%"
              >
                <stop offset="0%" stopColor="rgb(67,186,255)" stopOpacity="1" />
                <stop
                  offset="100%"
                  stopColor="rgb(113,65,177)"
                  stopOpacity="1"
                />
              </linearGradient>
            </defs>
            <path
              fillRule="evenodd"
              fill="rgb(43, 142, 254)"
              d="M19.529,202.280 L230.531,14.698 C254.559,-6.661 291.353,-4.498 312.714,19.528 L500.295,230.531 C521.656,254.558 519.493,291.353 495.466,312.713 L284.463,500.295 C260.436,521.655 223.641,519.492 202.281,495.465 L14.699,284.462 C-6.660,260.435 -4.498,223.640 19.529,202.280 Z"
            />
            <path
              fill="url(#PSgrad_0)"
              d="M19.529,202.280 L230.531,14.698 C254.559,-6.661 291.353,-4.498 312.714,19.528 L500.295,230.531 C521.656,254.558 519.493,291.353 495.466,312.713 L284.463,500.295 C260.436,521.655 223.641,519.492 202.281,495.465 L14.699,284.462 C-6.660,260.435 -4.498,223.640 19.529,202.280 Z"
            />
          </svg>
        </div>
        <div className="shape-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="972.5px"
            height="970.5px"
          >
            <path
              fillRule="evenodd"
              stroke="rgb(255, 255, 255)"
              strokeWidth="1px"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              fill="none"
              d="M38.245,381.102 L435.258,28.158 C480.467,-12.32 549.697,-7.964 589.888,37.244 L942.832,434.257 C983.23,479.466 978.955,548.697 933.746,588.888 L536.733,941.832 C491.524,982.23 422.293,977.955 382.103,932.745 L29.158,535.732 C-11.32,490.523 -6.963,421.293 38.245,381.102 Z"
            />
          </svg>
        </div>
        <div className="container">
          <div className="page-banner-wrap">
            <div className="row">
              <div className="col-lg-12">
                {/* <!-- Page Banner Content Start --> */}
                <div className="page-banner text-center">
                  <h2 className="title">Why Choose Us</h2>
                  <ul className="breadcrumb justify-content-center">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Why Choose Us
                    </li>
                  </ul>
                </div>
                {/* <!-- Page Banner Content End --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Page Banner End --> */}

      {/* <!-- Choose Us Start --> */}
      <div className="section techwix-choose-us-section techwix-choose-us-section-03 section-padding">
        <div className="container">
          {/* <!-- Choose Us Wrap Start --> */}
          <div className="choose-us-wrap">
            <div className="section-title text-center">
              <h3 className="sub-title">REASON TO CHOOSE US</h3>
              <h2 className="title">
                We provide truly prominent IT solutions.
              </h2>
            </div>
            <div className="choose-us-content-wrap">
              <div className="row">
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/ser-icon9.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Infrustructure <br /> Technology
                        </Link>
                      </h3>
                      <p>
                        Built on advanced blockchain frameworks, our
                        infrastructure ensures seamless, secure, and scalable
                        tech solutions for Web3 evolution
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/counter-3.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Highly professional team members
                        </Link>
                      </h3>
                      <p>
                        Our skilled team combines extensive blockchain expertise
                        with hands-on experience to create innovative,
                        Cutting-edge digital solutions.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/ser-icon10.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Security <br /> Management
                        </Link>
                      </h3>
                      <p>
                        Built-in end-to-end security guarantees all digital
                        transactions maintain trust, data integrity, and full
                        compliance at every phase.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/ser-icon12.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Desktop <br /> Computing
                        </Link>
                      </h3>
                      <p>
                        Robust desktop computing solutions for blockchain
                        development, crypto trading, and decentralized app
                        system management.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/counter-1.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Scalable Blockchain
                          <br /> Architecture
                        </Link>
                      </h3>
                      <p>
                        Optimized for performance and Scalability, our structure
                        delivers safe, Adaptable foundations for cutting-edge
                        Web3 apps and platforms.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/counter-2.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Ideas for high return investment
                        </Link>
                      </h3>
                      <p>
                        Maximize returns with secure blockchain ventures,
                        cutting-edge DeFi platforms, and forward-thinking crypto
                        asset strategies.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/ser-icon21.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Fully high IT <br /> Managment
                        </Link>
                      </h3>
                      <p>
                        Comprehensive IT solutions guaranteeing peak efficiency,
                        robust protection, and flawless functionality for all
                        digital and blockchain systems.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/ser-icon22.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">Data secure & Managment</Link>
                      </h3>
                      <p>
                        Cutting-edge data protection security and management
                        solutions built for assurance, reliability, performance,
                        and seamless digital integration.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Choose Us Wrap End --> */}
        </div>
      </div>
      {/* <!-- Choose Us End --> */}

      {/* <!-- Skill Start --> */}
      <div
        className="section techwix-skill-section-02 section-padding"
        style={{ backgroundImage: " url(assets/images/bg/skill-bg.jpg)" }}
      >
        <div className="container">
          <div className="skill-wrap">
            <div className="row">
              <div className="col-lg-6">
                {/* <!-- Skill Left Start --> */}
                <div className="skill-left">
                  <div className="section-title">
                    <h2 className="title">
                      Preparing for your success, we provide truly prominent IT
                      solutions
                    </h2>
                  </div>
                  <div className="experience-wrap">
                    <div className="experience">
                      <h2 className="number">25</h2>
                      <span>
                        Years of experience
                      </span>
                    </div>
                    <div className="experience-text">
                      <p>
                        Accelerate innovation with world-className tech teams
                        We’ll match you to an entire remote team of incredible
                        freelance talent for all your software development
                        needs.
                      </p>
                      <Link className="learn-more" href="#">
                        learn More About Us{" "}
                        <i className="fas fa-long-arrow-alt-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <!-- Skill Left End --> */}
              </div>
              <div className="col-lg-6">
                {/* <!-- Skill Right Start --> */}
                <div className="skill-right">
                  <div className="counter-bar">
                    {/* <!-- Skill Item Start --> */}
                    <div className="skill-item">
                      <span className="title">IT Managment</span>
                      <SkillBar title={80} percentage={80} />
                    </div>
                    {/* <!-- Skill Item End --> */}
                    {/* <!-- Skill Item Start --> */}
                    <div className="skill-item">
                      <span className="title">Data Security</span>
                      <SkillBar title={95} percentage={95} />
                    </div>
                    {/* <!-- Skill Item End --> */}
                    {/* <!-- Skill Item Start --> */}
                    <div className="skill-item">
                      <span className="title">Information Technology</span>
                      <SkillBar title={80} percentage={80} />
                    </div>
                    {/* <!-- Skill Item End --> */}
                    {/* <!-- Skill Item Start --> */}
                    <div className="skill-item">
                      <span className="title">Technology Consultant</span>
                      <SkillBar title={90} percentage={90} />
                    </div>
                    {/* <!-- Skill Item End -->// */}
                  </div>
                </div>
                {/* <!-- Skill Right End --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Skill End --> */}

      {/* <!-- Cta Start --> */}
      <div
        className="section techwix-cta-section-04 techwix-cta-section-06 section-padding"
        style={{ backgroundImage: "url(/images/bg/cta-bg5.jpg)" }}
      >
        <div className="container">
          <div className="cta-wrap">
            <div className="row align-items-center">
              <div className="col-lg-7">
                {/* <!-- Cta Left Start --> */}
                <div className="cta-left">
                  <div className="section-title">
                    <h2 className="title white">
                      To make requests for further information, contact us{" "}
                    </h2>
                  </div>
                </div>
                {/* <!-- Cta Left End --> */}
              </div>
              <div className="col-lg-5">
                {/* <!-- Cta Right Start --> */}
                <div className="cta-info text-center">
                  <div className="cta-icon">
                    <img src="/images/cta-icon2.png" alt="" />
                  </div>
                  <div className="cta-text">
                    <p>Call Us For Any inquiry</p>
                    <h3 className="number">+44 920 090 505</h3>
                  </div>
                </div>
                {/* <!-- Cta Right End --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Cta End --> */}

      {/* <!-- Testimonial Start  --> */}

      {/* <!-- Testimonial End  --> */}

      {/* <!-- Brand Logo Start --> */}
      <div className="section techwix-brand-section techwix-brand-section-03">
        <div className="container">
          {/* <!-- Brand Wrapper Start --> */}
          <div className="brand-wrapper text-center">
            {/* <!-- Brand Active Start --> */}
            <div className="brand-active">
              <div className="swiper-container">
                <Swiper
                  slidesPerView={5}
                  spaceBetween={30}
                  loop={true} // 👈 This enables infinite loop
                  pagination={{ dynamicMainBullets: true }}
                  //   modules={[Pagination]}
                  className="case-swiper"
                >
                  {slidesBrand.map((slide, i) => (
                    <SwiperSlide key={slide.id}>
                      <div className="swiper-slide single-brand">
                        <img src={slide.image} alt={`Brand ${i + 1}`} />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
            {/* <!-- Brand Active End --> */}
          </div>
          {/* <!-- Brand Wrapper End --> */}
        </div>
      </div>
      {/* <!-- Brand Logo End --> */}

      {/* <!-- Cta Start --> */}
      <div className="section techwix-cta-section-02 section-padding-02">
        <div className="container">
          {/* <!-- Cta Wrap Start --> */}
          <div
            className="cta-wrap"
          >
            <div className="row align-items-center">
              <div className="col-xl-9 col-lg-8">
                {/* <!-- Cta Content Start --> */}
                <div className="cta-content">
                  <div className="cta-icon">
                    <img src="/images/cta-icon2.png" alt="image" />
                  </div>
                  <p>We’re Delivering the best customer Experience</p>
                </div>
                {/* <!-- Cta Content End --> */}
              </div>
              <div className="col-xl-3 col-lg-4">
                {/* <!-- Cta Button Start --> */}
                <div className="cta-btn">
                  <Link className="btn btn-white" href="#">
                    +44 920 090 505
                  </Link>
                </div>
                {/* <!-- Cta Button End --> */}
              </div>
            </div>
          </div>
          {/* <!-- Cta Wrap End --> */}
        </div>
      </div>
      {/* <!-- Cta End --> */}
      <Footer />
    </>
  );
};

export default page;
